var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"black"}},[_c('img',{staticStyle:{"width":"100%","margin-top":"56px"},attrs:{"src":this.campaing}})])
}
var staticRenderFns = []

export { render, staticRenderFns }